import { Link, Outlet } from 'react-router-dom';

function Layout() {

  return (
    <div className="layout">
      <nav className="nav">
        <div className="nav-inner">
          <Link to="/" className="nav-logo">
            <img src="/logo.png" alt="Royco" className="nav-logo-img" />
          </Link>
          <div className="nav-right">
            <a
              href="https://app.royco.org"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-cta"
            >
              Launch Royco
            </a>
          </div>
        </div>
      </nav>
      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}

export default Layout;
